// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17ZKP","icon":"styles_icon__3LsnS"};